var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rbv-dropdown",
    {
      staticClass: "rb-action-select",
      attrs: {
        align: _vm.align,
        "is-open": _vm.open,
        "backdrop-style": "backdrop",
      },
      on: { close: _vm.toggle },
    },
    [
      _c(
        "div",
        {
          attrs: { slot: "toggler" },
          on: { click: _vm.toggle },
          slot: "toggler",
        },
        [
          _c(
            "div",
            {
              staticClass: "button control filter",
              class: { inactive: !(_vm.match && _vm.theValue), dark: _vm.dark },
            },
            [
              !_vm.$slots.default
                ? [
                    _vm._t("icon"),
                    _c("label", { staticClass: "label" }, [_vm._t("label")], 2),
                    !_vm.open
                      ? [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.match && _vm.theValue ? _vm.match.text : ""
                              ) +
                              " "
                          ),
                        ]
                      : _vm.search
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchTerm,
                              expression: "searchTerm",
                            },
                          ],
                          ref: "input",
                          staticClass: "input",
                          domProps: { value: _vm.searchTerm },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchTerm = $event.target.value
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._t("default"),
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("keyboard_arrow_down"),
              ]),
            ],
            2
          ),
        ]
      ),
      _c(
        "ul",
        {
          staticClass: "dropdown",
          class: { dark: _vm.dark },
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        _vm._l(_vm.searchedItems, function (item) {
          return _c(
            "li",
            {
              key: item.id,
              class: {
                item: true,
                active: _vm.selected(item.id),
                [_vm.sortOrder]: _vm.selected(item.id),
              },
              on: {
                click: function ($event) {
                  return _vm.select(item.id)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(item.text) + " "),
              _vm.sorter && item.id
                ? [
                    _c("i", { staticClass: "material-icons icon2" }, [
                      _vm._v("sort"),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }